<div fxFlex="50" class="vertial-border mt-12">
    <div fxLayout="row" id="am-1107">
        <p class="insurance font-size-16">
            {{ "APP_CREATE_CASE.INSURANCE_COMPANY" | translate }}
        </p>
    </div>

    <div fxLayout="row" class="vertial-border" id="am-1108">
        <mat-icon mat-card-avatar>
            <ng-container *ngIf="companyLogoId !== null && companyLogoId !== ''">
                <app-pcx-avatar-by-fle-id
                    [size]="24"
                    bgColor="#989898"
                    class=""
                    fgColor="#FFFFFF"
                    initialsSize="1"
                    [FileId]="companyLogoId"
                    [DisplayName]="companyName"
                >
                </app-pcx-avatar-by-fle-id>
            </ng-container>
        </mat-icon>
        <div id="am-1109">
            <p class="insurance_provide insurance-sub font-size-12 pl-0 dark-color-80 subtitle-1-bold word-break">
                {{ companyName }}
            </p>
            <p class="dark-color-60 subtitle-2-regular word-break">
                {{ departmentEmail || "" }}
            </p>
        </div>
    </div>
</div>

<div class="vertical-border mt-12 pl-16" fxFlex="50" id="am-1110">
    <div fxLayout="row">
        <p class="insurance font-size-16">
            {{ "APP_CREATE_CASE.CLIENTELE" | translate }}
        </p>
    </div>

    <div fxLayout="row">
        <div>
            <p class="insurance_provide insurance-sub font-size-12 pl-0 dark-color-80 subtitle-1-bold word-break">
                {{ departmentName }}
            </p>
        </div>
    </div>
</div>
